export const CREATE_TICKET_PATH = '/platform/create-ticket';
